import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Mountain } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      const from = location.state?.from || "/dashboard";
      navigate(from);
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail) || e.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="paper-grain min-h-[calc(100vh-80px)] flex items-center justify-center px-6 py-16" data-testid="login-page">
      <div className="w-full max-w-md paper-card p-10">
        <div className="flex items-center gap-2 mb-6">
          <Mountain className="w-6 h-6" style={{ color: "var(--mp-terracotta)" }}/>
          <span className="font-script text-2xl text-[#5C5C5C]">welcome back</span>
        </div>
        <h1 className="font-serif-display text-4xl mb-8">Log in.</h1>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-xs uppercase tracking-[0.18em] font-semibold mb-2 text-[#5C5C5C]">Email</label>
            <input data-testid="login-email-input" type="email" required className="mp-input" value={email} onChange={(e) => setEmail(e.target.value)}/>
          </div>
          <div>
            <label className="block text-xs uppercase tracking-[0.18em] font-semibold mb-2 text-[#5C5C5C]">Password</label>
            <input data-testid="login-password-input" type="password" required className="mp-input" value={password} onChange={(e) => setPassword(e.target.value)}/>
          </div>
          {error && <p data-testid="login-error" className="text-sm text-[#8C3A3A]">{error}</p>}
          <button data-testid="login-submit-btn" type="submit" disabled={loading} className="btn-primary w-full mt-6">
            {loading ? "..." : "Log in"}
          </button>
        </form>
        <p className="text-sm text-[#5C5C5C] mt-6">
          New here?{" "}
          <Link to="/register" className="text-[#8C3A3A] underline underline-offset-4" data-testid="login-to-register-link">
            Claim your screen name
          </Link>
          {" · "}
          <Link to="/forgot-password" className="text-[#8C3A3A] underline underline-offset-4" data-testid="login-to-forgot-link">
            Forgot password?
          </Link>
        </p>
      </div>
    </div>
  );
}
